import * as React from "react"
import {useDispatch, useSelector} from "react-redux"
import _ from "lodash"
import useComponentWillMount from "../../core/utils/componentUtils"
import {loadDemographicsDataAction} from "../redux/refdb.actions"
import {getDisplayDemographics} from "../redux/refdb.selector"
import "./DisplayDemographicPanel.scss"

type Props = {}

const DisplayDemographicPanel: React.FC<Props> = () => {
    const dispatch = useDispatch()

    useComponentWillMount(() => {
        dispatch(loadDemographicsDataAction())
    })
    const displayData = useSelector(getDisplayDemographics)

    const style = (value) => {
        const percent = 75 / _.size(value)
        return {width: `${percent}%`}
    }
    return (
        <div style={{height: "100%", paddingTop: "0.5em"}}>
            <table className="ag-theme-balham">
                <tr style={{height: "33px", minHeight: "33px"}}>
                    <th
                        style={{width: "25%"}}
                        className="biocrates-header-cell"
                    >
                        Category
                    </th>
                    <th className="biocrates-header-cell">
                        Demographics information of all samples included with
                        selected filter options
                    </th>
                </tr>
            </table>
            {Object.entries(displayData).map(([key, value]) => {
                return (
                    <table
                        style={{border: "1px solid", width: "100%"}}
                        className="ag-theme-balham"
                    >
                        {/* eslint-disable-next-line react/jsx-no-comment-textnodes */}
                        <tr>
                            <td
                                style={{width: "25%"}}
                                rowSpan={2}
                                className="ag-theme-balham ag-row-odd biocrates-cell"
                            >
                                {key}
                            </td>
                            {/* eslint-disable-next-line react/jsx-no-comment-textnodes */}
                            {
                                // eslint-disable-next-line array-callback-return
                                Object.entries(value).map(([label, count]) => {
                                    return (
                                        <td
                                            style={style(value)}
                                            className="ag-row-odd biocrates-cell"
                                        >
                                            {label}
                                        </td>
                                    )
                                })
                            }
                        </tr>
                        <tr>
                            {Object.entries(value).map(([label, count]) => {
                                return (
                                    <td
                                        className="biocrates-cell"
                                        style={style(value)}
                                    >
                                        {count}
                                    </td>
                                )
                            })}
                        </tr>
                    </table>
                )
            })}
        </div>
    )
}
export default DisplayDemographicPanel
